import { render, staticRenderFns } from "./selectTcComponent.vue?vue&type=template&id=30601665&scoped=true"
import script from "./selectTcComponent.vue?vue&type=script&lang=js"
export * from "./selectTcComponent.vue?vue&type=script&lang=js"
import style0 from "./selectTcComponent.vue?vue&type=style&index=0&id=30601665&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30601665",
  null
  
)

export default component.exports